import React, { PureComponent } from "react";

import Box from "grommet/components/Box";
import Heading from "grommet/components/Heading";

import Total from "./total";
import Legend from "./legend";
import AnnotatedMeter from "./annotated_meter";
import { translate } from "react-i18next";
import AppSettings from "../../utils/appSettings";
import Label from "grommet/components/Label";
import Value from "grommet/components/Value";
import currencyFormatter from "currency-formatter";

class ViewerEtatVsEtude extends PureComponent {
  constructor(props) {
    super(props);
    this.t = props.t;
  }
  getSetting = shortcode => {
    let setting;
    this.props.settings.forEach(s => {
      if (s.shortcode === shortcode) {
        setting = s;
      }
    });
    if (!setting) {
      console.error("This setting does not exist: " + shortcode);
    }
    return setting.content.value;
  };

  _renderDetails = ({ baseCalcul, sumEtat, sumEtude }) => {
    return (
      <Box
        alignSelf="stretch"
        pad={{ between: "medium", horizontal: "medium", vertical: "medium" }}
        direction="column"
      >
        {baseCalcul !== undefined ? (
          <Box
            margin={{ vertical: "small" }}
            padding={{ horizontal: "medium" }}
            responsive={true}
            direction="row"
            justify="between"
            align="center"
            flex={true}
          >
            <Label size="medium" strong style={{ margin: 0 }}>
              {this.t("Base de calcul")}:
            </Label>
            <Value
              value={currencyFormatter.format(
                baseCalcul,
                AppSettings.currencyOptionFormater
              )}
              units="€"
              size="small"
            />
          </Box>
        ) : (
          undefined
        )}

        <Box
          margin={{ vertical: "small" }}
          padding={{ horizontal: "medium" }}
          responsive={true}
          direction="row"
          justify="between"
          align="center"
          flex={true}
        >
          <Label size="medium" style={{ margin: 0 }}>
            {this.t("Frais et Taxes Administratives")}:
          </Label>
          <Value
            value={currencyFormatter.format(
              sumEtat,
              AppSettings.currencyOptionFormater
            )}
            units="€"
            size="small"
          />
        </Box>
        <Box
          margin={{ vertical: "small" }}
          padding={{ horizontal: "medium" }}
          responsive={true}
          direction="row"
          justify="between"
          align="center"
          flex={true}
        >
          <Label size="medium" style={{ margin: 0 }}>
            {this.t("Vacations et Honoraires de l'Etude")}:
          </Label>
          <Value
            value={currencyFormatter.format(
              sumEtude,
              AppSettings.currencyOptionFormater
            )}
            units="€"
            size="small"
          />
        </Box>
      </Box>
    );
  };
  render() {
    let sumEtat = 0;
    let sumEtude = 0;
    let sum = 0;
    //There is a read-only bug here and I don't know why
    let series = this.props.series;
    let pourcentageEtat = this.getSetting("frais_divers_ventilation_etat");
    //value.sort((a, b) => {return a.tva < b.tva});
    series.filter(s => s.etat && !s.frais).forEach(s => (sumEtat += s.value));
    series.filter(s => !s.etat && !s.frais).forEach(s => (sumEtude += s.value));
    //Les frais sont majoré.
    series.filter(s => s.frais).forEach(s => {
      sumEtat += s.value * (pourcentageEtat / 100);
      sumEtude += s.value * ((100 - pourcentageEtat) / 100);
    });

    series.forEach(s => (sum += s.value));
    let seriesMeter = [
      {
        colorIndex: "neutral-1",
        label: this.t("Frais et Taxes Administratives"),
        value: sumEtat
      },
      {
        colorIndex: "neutral-2",
        label: this.t("Vacations et Honoraires de l'Etude"),
        value: sumEtude
      }
    ];
    series.map(s => {
      s.colorIndex = s.etat ? "neutral-1" : "neutral-2";
      //Dual Color are unfortunately hardcoded right now
      s.dualColor = s.frais;
      s.label = (s.label);
      return s;
    });
    let seriesLegend = series;
    let baseCalcul = this.props.baseCalcul;
    return (
      <Box align="center" alignSelf="stretch">
        {this.props.computationAppName ? (
          <Box margin="medium">
            <Heading tag="h2">{this.props.computationAppName}</Heading>
          </Box>
        ) : null}
        <Box margin="medium">
          <AnnotatedMeter
            i18n={this.props.i18n}
            size="medium"
            type="bar"
            units="€"
            responsive={true}
            legend={false}
            series={seriesMeter}
          />
        </Box>

        {!this.props.noDetails &&
          this._renderDetails({ baseCalcul, sumEtat, sumEtude })}

        <Box alignSelf={this.props.stretch ? "stretch" : "center"}>
          {seriesLegend.filter(s => !s.tva).length > 0 ? (
            <Box margin={{ vertical: "small" }}>
              <Heading strong={true} tag="h4" truncate={false} uppercase={true}>
                Debours
              </Heading>
              <Legend
                i18n={this.props.i18n}
                series={seriesLegend.filter(s => !s.tva)}
                units="€"
                total={true}
              />
            </Box>
          ) : null}
          <Box margin={{ vertical: "small" }}>
            {seriesLegend.filter(s => s.tva).length > 0 ? (
              <React.Fragment>
                <Heading
                  strong={true}
                  tag="h4"
                  truncate={false}
                  uppercase={true}
                >
                  Facture
                </Heading>
                <Legend
                  i18n={this.props.i18n}
                  series={seriesLegend.filter(s => s.tva)}
                  units="€"
                  labelTotal="Total (avec TVA)"
                  total={true}
                />
              </React.Fragment>
            ) : null}

            <Total total={sum} />
          </Box>
        </Box>
      </Box>
    );
  }
}
export default translate()(ViewerEtatVsEtude);



// WEBPACK FOOTER //
// ./src/computationApps/components/viewer/ViewerEtatVsEtude.js